import React, { useState } from "react";
import {
  Button,
  ContainerForm,
  ContainerInput,
  Input,
  TextHead,
  TextRegular,
  ContainerAlert,
} from "./LoginForm.styled";
import { func } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { usePostLogin } from "../../../../networks";
import { useUserData } from "../../../../store/user";

const LoginForm = ({ isMobileView }) => {
  const formRef = React.useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isErrorLogin, setIsErrorLogin] = useState(false);
  const [isFocusEmail, setIsFocusEmail] = useState(false);
  const [isFocusPassword, setIsFocusPassword] = useState(false);

  const navigate = useNavigate();
  const Swal = require("sweetalert2");

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };
  const handleChangePassword = (event) => {
    // console.log(event.target.value);
    setPassword(event.target.value);
  };

  const { setAccessToken, setEmail: setEmailState } = useUserData();

  const { mutateAsync: login } = usePostLogin();

  const validateData = (value) => {
    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return pattern.test(value);
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (validateData(email) && password.length >= 4) {
      try {
        const postData = await login({ email, password });

        if (!!postData) {
          setEmailState(email);
          setAccessToken(postData?.data?.access_token);
          navigate(`/`);
        }
      } catch (error) {
        setIsErrorLogin(true);
      }
    } else {
      setIsErrorLogin(true);
    }
  };

  // Prevent on submit form
  React.useEffect(() => {
    if (formRef.current) {
      formRef.current.addEventListener("submit", (event) => {
        event.preventDefault();
        handleLogin();
      });
    }
  }, [formRef]);

  return (
    <ContainerForm>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <TextHead>Login</TextHead>
        <TextRegular fontSize={isMobileView ? "14px" : "16px"}>
          Masukkan detail akun kamu
        </TextRegular>
      </div>
      <form ref={formRef}>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <ContainerInput
            onFocus={() => setIsFocusEmail(true)}
            onBlur={() => setIsFocusEmail(false)}
            style={{
              border: isFocusEmail ? "1px solid #00BCF1" : "1px solid #b8c1cb",
            }}
          >
            <img
              style={{ marginLeft: "8px" }}
              src={func.getStaticImg("/icon/credential.svg")}
            ></img>
            <Input
              placeholder="Email"
              type="email"
              onChange={handleChangeEmail}
            />
          </ContainerInput>
          <ContainerInput
            onFocus={() => setIsFocusPassword(true)}
            onBlur={() => setIsFocusPassword(false)}
            style={{
              border: isFocusPassword
                ? "1px solid #00BCF1"
                : "1px solid #b8c1cb",
            }}
          >
            <img
              style={{ marginLeft: "8px" }}
              src={func.getStaticImg("/icon/lock.svg")}
            ></img>
            <Input
              placeholder="Password"
              type="password"
              onChange={handleChangePassword}
            />
          </ContainerInput>
          {isErrorLogin && (
            <ContainerAlert>
              <img
                style={{ marginLeft: "8px" }}
                src={func.getStaticImg("/icon/sa-error-circle.svg")}
              ></img>
              <TextRegular fontSize={"11px"} style={{ marginLeft: "8px" }}>
                Email atau Password kamu salah nih...
              </TextRegular>
            </ContainerAlert>
          )}
        </div>
        <Button onClick={handleLogin}>Masuk</Button>
      </form>
      <TextRegular style={{ alignSelf: "center" }} fontSize={"13px"}>
        Belum punya akun?{" "}
        <span
          onClick={() => navigate("/registrasi")}
          style={{
            color: "#00BCF1",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          <u>Register</u>
        </span>
      </TextRegular>
    </ContainerForm>
  );
};

export default LoginForm;
